const formatPriceRange = (min, max, currency = "USD") =>
  min === max ? `${currency} ${min}` : `${currency} ${min} - ${max}`;

const formatPrice = (price, currency = "USD") =>
 `${currency} ${price}`;

export const mapToModalItem = (item) =>
  item
    ? {
        ...item,
        img: item.prev,
        quantity: item.availability,
        desc: item.description,
        size: item.size,
        price: item.price,
      }
    : null;

export const mapPosterToCardProps = (poster) => ({
  image: poster.prev || poster.image,
  title: poster.name,
  edition: poster.edition,
  description: poster.description,
  year: poster.year,
  sizes: poster.sizes,
  priceLabel: formatPriceRange(
    poster.priceMin,
    poster.priceMax,
    poster.currency,
  ),
  currency: "USD",
  handSigned: true,
  ctaLabel: "Purchase",
});

export const mapPhysicalEditionToCardProps = (item) => ({
  image: item.prev || item.preview,
  title: item.name,
  edition: item.availability,
  year: item.year,
  sizes: item.sizes,
  type: item.type,
  priceLabel: formatPrice(item.price),
  currency: "USD",
  handSigned: false,
  ctaLabel: "Purchase",
  description: item.description,
});
